import axios from '../axios';

export default {
  getAbonents (options) {
    const params = {};
    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    if (options.include && options.include.length) {
      params.include = options.include.join();
    }

    if (options.pagination) {
      params.pagination = 1;
    }

    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/abonent?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  getAbonent (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/abonent/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  newAbonent (data) {
    return new Promise((resolve, reject) => {
      axios.post('/abonent', data)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  abonentsCreateByPhone (params) {
    return new Promise((resolve, reject) => {
      axios.post('/abonent/create-by-phone', params)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  simpleUpdateAbonent ({ dataAbonent, idAbonent }) {
    return new Promise((resolve, reject) => {
      axios.put(`/abonent/${idAbonent}/simple`, dataAbonent)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  updateAbonent ({ dataAbonent, idAbonent }) {
    return new Promise((resolve, reject) => {
      axios.put(`/abonent/${idAbonent}`, dataAbonent)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  deleteAbonent (id, comment) {
    return new Promise((resolve, reject) => {
      const isComment = comment ? `?comment=${comment}` : '';
      axios.delete(`/abonent/${id}${isComment}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => reject(error));
    });
  },

  exportCsv () {
    return new Promise((resolve, reject) => {
      axios.get('/abonent/export-csv', { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  exportCsvByAddress (doorphoneId) {
    return new Promise((resolve, reject) => {
      axios.get('/abonent/export-csv-by-address', {
        responseType: 'blob',
        params: {
          doorphone_id: doorphoneId,
        },
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  blockAccount (idAbonent) {
    return new Promise((resolve, reject) => {
      axios.post(`/abonent/${idAbonent}/block`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  unlockAccount (idAbonent) {
    return new Promise((resolve, reject) => {
      axios.post(`/abonent/${idAbonent}/unlock`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  forbidCarNumberActivation (idAbonent) {
    return new Promise((resolve, reject) => {
      axios.post(`/abonent/${idAbonent}/forbid-car-number-activation`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  allowCarNumberActivation (idAbonent) {
    return new Promise((resolve, reject) => {
      axios.post(`/abonent/${idAbonent}/allow-car-number-activation`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },

  getDeletedAbonent (options) {
    const params = {};
    if (options.page) {
      params.page = options.page;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/abonent/deleted?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
